import gql from 'graphql-tag';

/**
 * Fields of the project's measurement point operator that the project page reads (documents).
 * Shared by the page query and the save of the block project-measurement-point-operator, so a
 * block save replaces every key of the stored operator and no values of the previous one remain.
 */
export const MEASUREMENT_POINT_OPERATOR_OF_PROJECT_FIELDS = gql`
  fragment measurementPointOperatorOfProjectFields on MeasurementPointOperator {
    id
    number
    name
    street
    streetNumber
    zip
    city
    msbNumber
  }
`;
